import axios from 'axios';
import { getCurrentSession } from './services/cognito';

const instance = axios.create({
  // baseURL: 'http://localhost:8080/',
});

instance.interceptors.request.use(async (config) => {
  try {
    const session = await getCurrentSession();
    if (session) {
      config.headers.Authorization = `Bearer ${session.accessToken}`;
    }
  } catch {
    // No valid session — send request without auth header
  }
  return config;
});

export default instance;
